import { COUNTRY } from '~globals';
import { Country } from '~models/country';

import Facebook from './assets/facebook.svg';
import Instagram from './assets/instagram.svg';
import LinkedIn from './assets/linkedin.svg';
import Twitter from './assets/twitter.svg';

export type Social = 'facebook' | 'instagram' | 'linkedin' | 'twitter';

const socials: Record<
  Country,
  { label: string; items: { id: Social; Icon: React.FC<React.SVGProps<SVGSVGElement>>; url: string }[] }
> = {
  nl: {
    label: 'Socials',
    items: [
      {
        id: 'facebook',
        Icon: Facebook,
        url: 'https://www.facebook.com/insifyverzekeringen',
      },
      {
        id: 'instagram',
        Icon: Instagram,
        url: 'https://www.instagram.com/insify.nl',
      },
      {
        id: 'linkedin',
        Icon: LinkedIn,
        url: 'https://www.linkedin.com/company/insify',
      },
      {
        id: 'twitter',
        Icon: Twitter,
        url: 'https://twitter.com/insify',
      },
    ],
  },
  fr: {
    label: 'Socials',
    items: [
      {
        id: 'facebook',
        Icon: Facebook,
        url: 'https://www.facebook.com/insify.fr',
      },
      {
        id: 'instagram',
        Icon: Instagram,
        url: 'https://www.instagram.com/insify.fr',
      },
      {
        id: 'linkedin',
        Icon: LinkedIn,
        url: 'https://www.linkedin.com/company/insify',
      },
      {
        id: 'twitter',
        Icon: Twitter,
        url: 'https://twitter.com/insify',
      },
    ],
  },
  de: {
    label: 'Socials',
    items: [
      {
        id: 'facebook',
        Icon: Facebook,
        url: 'https://www.facebook.com/insify.de',
      },
      {
        id: 'instagram',
        Icon: Instagram,
        url: 'https://www.instagram.com/insify.de',
      },
      {
        id: 'linkedin',
        Icon: LinkedIn,
        url: 'https://www.linkedin.com/company/insify',
      },
      {
        id: 'twitter',
        Icon: Twitter,
        url: 'https://twitter.com/insify',
      },
    ],
  },
};

export const useSocials = () => socials[COUNTRY];
